export default {
  belowDesktop: '@media (max-width: 735px)',
  tablet: '@media (min-width: 415px)',
  desktop: '@media (min-width: 736px)',
}



// WEBPACK FOOTER //
// ./src/stylesheet/breakpoints.js